import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './i18n';
import styles from './styles.scss';

export default function Banner() {
  return (
    <div className={styles.banner}>
      <p className={styles.bannerText}>
        <FormattedMessage {...messages.bannerText} />
      </p>
      <a className={styles.bannerLink} href="https://my.tanda.co/timeclock/get_app" target="_blank" rel="noopener noreferrer">
        <FormattedMessage {...messages.bannerButtonText} />
      </a>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/shared/banner/index.jsx